import { green, red, yellow } from '@ant-design/colors';
import { ProdutoNcmStatus, ProdutoTipo } from './types/enum';

export const PRODUTO_TIPO_VENDA = [
    ProdutoTipo.Simples,
    ProdutoTipo.Kit,
    ProdutoTipo.Fabricado,
    ProdutoTipo.MateriaPrima,
    ProdutoTipo.Variacao,
    ProdutoTipo.Servico,
];

export const produtoNcmText: Record<ProdutoNcmStatus, string> = {
    [ProdutoNcmStatus.Valido]: 'Válido',
    [ProdutoNcmStatus.Invalido]: 'Inválido',
    [ProdutoNcmStatus.Pendente]: 'Pendente para análise',
    [ProdutoNcmStatus.Desconhecido]: 'Desconhecido',
};

export const produtoNcmColors: Record<ProdutoNcmStatus, string> = {
    [ProdutoNcmStatus.Invalido]: red.primary ?? '',
    [ProdutoNcmStatus.Pendente]: yellow.primary ?? '',
    [ProdutoNcmStatus.Valido]: green.primary ?? '',
    [ProdutoNcmStatus.Desconhecido]: '',
};
